/**
 * True when value matches axios error object returned by HttpClient error interceptor.
 * @param {unknown} value - Response from InterceptorClient.get
 * @returns {boolean}
 */
export function isInterceptorClientErrorShape(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const keys = Object.keys(value);
  return keys.length === 2 && keys.includes("status") && keys.includes("data") && typeof value.status === "number";
}

/**
 * True when payload looks like CMS batch map (path keys starting with `/`).
 * @param {unknown} value - Parsed API body
 * @returns {boolean}
 */
export function isLikelyCmsBatchPayload(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const keys = Object.keys(value);
  if (keys.length === 0) return true;
  return keys.some((k) => k.startsWith("/"));
}
